<div class="h-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <div class="border-b border-gray-100 px-5 py-4">
    <h3 class="font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
      Pending FOC Date
      <span class="ml-1 font-normal normal-case text-brand-muted">({{ total || '…' }})</span>
    </h3>
  </div>

  @if (loading) {
    <div class="flex items-center justify-center py-16">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="px-4 py-2">
      <p id="pending-foc-chart-desc" class="sr-only">
        Bar chart showing pending FOC date distribution. Contact support for tabular data.
      </p>
      <canvas
        baseChart
        id="pending-foc-chart"
        role="img"
        aria-label="Bar chart: Pending FOC Date"
        aria-describedby="pending-foc-chart-desc"
        height="220px"
        [data]="barChartData"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [type]="barChartType"
      ></canvas>
    </div>
  }
</div>
